/**
 * @description 会员模块路由
 * @author member-refactoring
 */

export const memberRouter = [
  {
    path: '/member/list',
    name: 'memberList',
    component: () => import('views/member/list/index.vue'),
    meta: { title: '会员', keepAlive: true }
  },
  {
    path: '/member/detail',
    name: 'memberDetail',
    component: () => import('views/member/detail/index.vue'),
    meta: { title: '会员详情' }
  },
  {
    path: '/member/history',
    name: 'memberHistory',
    component: () => import('views/member/history/index.vue'),
    meta: { title: '会员账单' }
  },
  {
    path: '/member/points/modify',
    name: 'memberPointsModify',
    component: () => import('views/member/points/modify/index.vue'),
    meta: { title: '修改积分' }
  },
  {
    path: '/member/card/form',
    name: 'memberCardForm',
    component: () => import('views/member/card/form/index.vue'),
    meta: { title: '会员卡设置' }
  },
  {
    path: '/member/card/detail',
    name: 'memberCardDetail',
    component: () => import('views/member/card/detail/index.vue'),
    meta: { title: '会员卡详情' }
  },
  {
    path: '/member/card/preview',
    name: 'memberCardPreview',
    component: () => import('views/member/card/preview/index.vue'),
    meta: { title: '卡面预览' }
  },
  {
    path: '/member/points/rules',
    name: 'memberPointsRules',
    component: () => import('views/member/points/rules/index.vue'),
    meta: { title: '积分规则' }
  },
  {
    path: '/member/guideAuthorize',
    name: 'memberGuideAuthorize',
    component: () => import('views/member/guideAuthorize/index.vue'),
    meta: { title: '授权引导' }
  },
  {
    path: '/member/activate/step1',
    name: 'memberActivateStep1',
    component: () => import('views/member/activate/step1/index.vue'),
    meta: { title: '开卡-填写信息' }
  },
  {
    path: '/member/activate/step2',
    name: 'memberActivateStep2',
    component: () => import('views/member/activate/step2/index.vue'),
    meta: { title: '开卡-绑定' }
  },
  {
    path: '/member/activate/step3',
    name: 'memberActivateStep3',
    component: () => import('views/member/activate/step3/index.vue'),
    meta: { title: '开卡-充值' }
  },
  {
    path: '/member/bindWechat',
    name: 'memberBindWechat',
    component: () => import('views/member/bindWechat/index.vue'),
    meta: { title: '绑定微信' }
  }
]
